import React from "react";
import ClassNames from "classnames";
import PURCHASE_OPTIONS from "./purchase-options";

class Purchase extends React.Component {
  constructor(props) {
    super(props);
  }

  calculateDiscount() {
    let product_price = Number(
      this.props.product.variants[this.props.selectedVariantIndex].price
    );
    let subscription_price = Number(
      this.props.subscription.variants[this.props.selectedVariantIndex].price
    );
    let difference = product_price - subscription_price;
    difference = Math.round(difference);
    let discount = (difference / product_price) * 100;
    return Math.round(discount);
  }

  render() {
    let price = this.props.variant.price;
    let discount = this.calculateDiscount();

    let discountPrice = this.props.subscription.variants[
      this.props.selectedVariantIndex
    ].price;

    return (
      <div className="Purchase">
        <div
          className={ClassNames("one-time", {
            active: this.props.selected === PURCHASE_OPTIONS.ONE_TIME
          })}
          onClick={() => {
            this.props.update(PURCHASE_OPTIONS.ONE_TIME);
          }}
        >
          <div className="radio" />
          <div className="info">
            <span className="label">One time purchase</span>

            <span className="price">
              {new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "USD"
              }).format(price)}
            </span>
          </div>
        </div>

        <div
          className={ClassNames("subscription", {
            active: this.props.selected === PURCHASE_OPTIONS.SUBSCRIPTION
          })}
          onClick={() => {
            this.props.update(PURCHASE_OPTIONS.SUBSCRIPTION);
          }}
        >
          <div className="radio" />
          <div className="info">
            <span className="label">Subscribe & Save – {discount}% Off</span>

            <span className="price">
              {new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "USD"
              }).format(discountPrice)}
            </span>

            <span className="save">
              Save{" "}
              {new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "USD"
              }).format(price - discountPrice)}
            </span>
            <a className="learn" onClick={this.props.handleMoreInfo}>
              Learn More
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Purchase;



// WEBPACK FOOTER //
// ./src/buy/purchase.js